export default __webpack_public_path__ + "static/media/Ballroll_00384.66a15bb3.png";